import { useMemo } from "react";
import ImagePreview from "../ImagePreview";

interface BackgroundImage {
  value: null;
  title: string;
  description: string;
  key: string;
  appName: string;
  fileId: number | null;
  filePath: string | null;
}

type BrandBackgroundImagesProps = {
  currentBrand: string;
  currentApp: "isn" | "fish_map" | "skipper_science";
  settings: {
    isnAdmin?: BackgroundImage[];
    fishMap?: BackgroundImage[];
    skipperScience?: BackgroundImage[];
  };
  getUniversalSettings: () => void;
};

export const BrandBackgroundImages: React.FC<BrandBackgroundImagesProps> = ({
  currentBrand,
  currentApp,
  settings,
  getUniversalSettings,
}) => {
  if (currentBrand !== "isn_admin") return null;

  const ALLOWED_KEYS: ReadonlySet<string> = new Set([
    "login_page_image",
    "forget_password_page_image",
    // "observer_mobile_dashboard_image",
    // "observer_offline_checklist_image",
    // "observer_dashboard_web_image",
  ]);

  const items = useMemo(() => {
    const appSettingsMap: Record<string, BackgroundImage[] | undefined> = {
      isn: settings?.isnAdmin,
      fish_map: settings?.fishMap,
      skipper_science: settings?.skipperScience,
    };

    return (appSettingsMap[currentApp] ?? []).filter((i) =>
      ALLOWED_KEYS.has(i.key)
    );
  }, [currentApp, settings]);

  if (!items.length) return null;

  return (
    <div className="flex flex-wrap items-start justify-start w-full gap-4">
      {items.map((setting: any) => (
        <ImagePreview
          key={`${setting.key}-${setting.fileId ?? "new"}`}
          title={setting.title}
          description={setting.description}
          fileId={setting.fileId}
          appName={setting.appName}
          filePath={setting.filePath}
          imageKey={setting.key}
          value={setting.value}
          getUniversalSettings={getUniversalSettings}
        />
      ))}
    </div>
  );
};
